export enum EmailAuthenticationType {
  MICROSOFT = "Microsoft",
  GOOGLE = "Google"
}
